import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["modal", "dimmer", "selectedCount", "checkbox"];
  static values = { collabPath: String };

  openModal(event) {
    if (event) event.preventDefault();
    this.modalTarget.style.visibility = "visible";
    this.modalTarget.style.opacity = "1";
    this.dimmerTarget.style.display = "block";
  }

  closeModal(event) {
    if (event) event.preventDefault();
    this.modalTarget.style.visibility = "hidden";
    this.modalTarget.style.opacity = "0";
    this.dimmerTarget.style.display = "none";
  }

  toggleCard(event) {
    if (event.target.closest("a")) return;

    var card = event.currentTarget;
    var checkCircle = card.querySelector(".check-circle");
    var checkbox = card.querySelector(".collab-checkbox");
    checkCircle.classList.toggle("checked");
    card.classList.toggle("deselected");
    checkbox.checked = checkCircle.classList.contains("checked");
    this.updateCount();
  }

  updateCount() {
    var count = this.checkboxTargets.filter(function (cb) {
      return cb.checked;
    }).length;
    if (this.hasSelectedCountTarget) {
      this.selectedCountTarget.textContent =
        count + " influencer" + (count !== 1 ? "s" : "") + " selected";
    }
  }

  submitCollab(event) {
    event.preventDefault();
    var checked = this.checkboxTargets.filter(function (cb) {
      return cb.checked;
    });
    if (checked.length === 0) {
      alert("Please select at least one influencer.");
      return;
    }
    if (typeof window.posthog !== "undefined") {
      window.posthog.capture("onboarding_collab_submitted", {
        influencer_count: checked.length,
      });
    }
    var params = checked
      .map(function (cb) {
        return "influencer_ids[]=" + cb.value;
      })
      .join("&");
    window.location.href = this.collabPathValue + "?" + params;
  }

  handleImageError(event) {
    var img = event.target;
    var fallbackUrl = img.dataset.fallbackUrl;

    // Try the fallback URL (original Instagram URL) first
    if (fallbackUrl && img.src !== fallbackUrl) {
      img.src = fallbackUrl;
      return;
    }

    // If fallback also fails, hide the image
    img.style.display = "none";
  }

  handleAvatarError(event) {
    var img = event.target;
    var initials = img.dataset.initials || "?";
    var sizeClass = img.classList.contains("large") ? " large" : "";

    var placeholder = document.createElement("div");
    placeholder.className = "rec-avatar-placeholder" + sizeClass;
    placeholder.textContent = initials;
    img.replaceWith(placeholder);
  }
}
